module.exports = __webpack_public_path__ + "78c63a3a7854cd99fcb8a856af10974a.jpg";